import { render, staticRenderFns } from "./StaffValidate.vue?vue&type=template&id=d2e3bf72&scoped=true&"
import script from "./StaffValidate.vue?vue&type=script&lang=js&"
export * from "./StaffValidate.vue?vue&type=script&lang=js&"
import style0 from "./StaffValidate.vue?vue&type=style&index=0&id=d2e3bf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e3bf72",
  null
  
)

export default component.exports